import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, map, tap } from "rxjs";
import { Injectable } from "@angular/core";
import { ActionResult, ActionResultList, Message } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class MessageService {
  private static _unreadMessages = new BehaviorSubject<Message[] | undefined>(undefined);
  private static _readMessages = new BehaviorSubject<Message[] | undefined>(undefined);

  static get unreadMessages() {
    return this._unreadMessages;
  }

  static get readMessages() {
    return this._readMessages;
  }

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  getUserMessages(read: boolean, onStartFetch?: () => void, onEndFetch?: () => void): Observable<Message[]> {
    onStartFetch?.();
    return this.http.post<ActionResultList<Message[], number>>(`${this.environmentService.getApiUrl()}/api/messages/user`, read).pipe(
      tap(() => onEndFetch?.()),
      map(value => value?.result?.length ? value.result : [])
    );
  }

  getMessageById(messageId: number | undefined, onSuccess: () => void, onError: () => void) {
    return this.http.post<ActionResult<Message>>(`${this.environmentService.getApiUrl()}/api/messages/byid`, messageId).subscribe(actionResult => {
      actionResult.resultCode !== -1 ? onSuccess() : onError();
    });
  }

  deleteMessages(messagesIds: number[], onSuccess: () => void, onError: () => void) {
    this.http.post<ActionResult<boolean>>(`${this.environmentService.getApiUrl()}/api/messages/delete`, messagesIds).subscribe(actionResult => {
      actionResult.resultCode !== -1 ? onSuccess() : onError();
    });
  }

  addMessage(message: Message, onSuccess: () => void, onError: () => void) {
    this.http.post<ActionResult<boolean>>(`${this.environmentService.getApiUrl()}/api/messages/add`, message).subscribe(actionResult => {
      actionResult.resultCode !== -1 ? onSuccess() : onError();
    });
  }
}
